module.exports = __webpack_public_path__ + "static/media/tv.0b6769df.svg";